export const coreCompetencies = [
  {
    icon: '🤝',
    title: '신뢰할 수 있는 파트너',
    desc: '건설사와 기획/설계 단계부터 다수의 프로젝트를 수행한 경험을 보유하여, 사업 초기부터 안정적인 관리 운영을 보장합니다.',
  },
  {
    icon: '⚙️',
    title: '체계적인 시스템 구축',
    desc: '40페이지 분량의 분야별 표준화 매뉴얼과 통합 구매관리 시스템을 적용하여 비용을 절감하고 업무의 신속성을 확보합니다.',
  },
  {
    icon: '👨‍🔬',
    title: '선진 관리 기법 및 전문 역량',
    desc: '다수의 면허와 자격증을 보유한 관리 분야별 핵심 인력이 특급 주상복합 입주관리 및 사전 컨설팅 노하우를 제공합니다.',
  },
];

export const landmarkProjects = [
  {
    name: '타워팰리스',
    desc: '대한민국 고급 주상복합의 상징',
    image: 'https://images.unsplash.com/photo-1521773632560-3d9c8a34235a?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: '아크로비스타',
    desc: '서초동의 프리미엄 주거 공간',
    image: 'https://images.unsplash.com/photo-1613946069412-38f7f1ff2b65?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: '용산 파크자이',
    desc: '도심 속 자연을 품은 랜드마크',
    image: 'https://images.unsplash.com/photo-1542928658-20a3-b85563?auto=format&fit=crop&w=800&q=80'
  }
];